import { db } from '@/firebaseConfig'

export function log (data) {
  data.time = new Date()
  db.collection('logs').add(data)
}
